<template>
  <nav class="navbar navbar-expand-lg navbar-dark py-lg-4" id="mainNav">
    <div class="container">
      <a
        class="navbar-brand text-uppercase text-expanded font-weight-bold d-lg-none"
        href="#"
        >Fabio Costa</a
      >
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarResponsive"
        aria-controls="navbarResponsive"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleCollapse"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav mx-auto">
          <router-link
            to="/"
            tag="li"
            active-class="active"
            exact
            class="nav-item px-lg-4"
          >
            <a class="nav-link text-uppercase text-expanded px-2"
              >Home
              <!-- <span class="sr-only">(current)</span> -->
            </a>
          </router-link>

          <router-link
            to="/about"
            tag="li"
            active-class="active"
            class="nav-item px-lg-4"
          >
            <a class="nav-link text-uppercase text-expanded px-2">About me</a>
          </router-link>

          <router-link
            to="/experiences"
            active-class="active"
            tag="li"
            class="nav-item px-lg-4"
          >
            <a class="nav-link text-uppercase text-expanded px-2"
              >Previous experiences</a
            >
          </router-link>

          <router-link
            to="/game"
            active-class="active"
            tag="li"
            class="nav-item px-lg-4"
          >
            <a class="nav-link text-uppercase text-expanded px-2"
              >Play a game</a
            >
          </router-link>

          <router-link
            to="/portfolio"
            active-class="active"
            tag="li"
            class="nav-item px-lg-4"
          >
            <a class="nav-link text-uppercase text-expanded px-2">Portfolio</a>
          </router-link>

          <router-link
            to="/contacts"
            active-class="active"
            tag="li"
            class="nav-item px-lg-4"
          >
            <a class="nav-link text-uppercase text-expanded px-2">Contact me</a>
          </router-link>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  methods: {
    toggleCollapse: function () {
      document.querySelector("#navbarResponsive").classList.toggle("collapse");
    },
  },
};
</script>

<style lang="scss">
#mainNav {
  background-color: fade-out(rgba(132, 135, 165, 0.9), 0.1);
  .navbar-brand {
    color: $white;
  }
  .navbar-nav {
    .nav-item {
      .nav-link {
        color: fade-out($white, 0.3);

        font-weight: 800;
      }
      &.active {
        .nav-link {
          color: rgb(42, 54, 107);
          background-color: rgb(124, 155, 206);
          border-radius: 0.5rem;
        }
      }
    }
  }
  @media (min-width: 992px) {
    .navbar-nav {
      .nav-item {
        .nav-link {
          font-size: 0.9rem;
          &:hover {
            color: fade-out($white, 0.6);
          }
        }
        &.active {
          .nav-link:hover {
            color: rgb(68, 83, 148);
          }
        }
      }
    }
  }
}
</style>
